import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "external-payment" }

import { invokeKey, routeKey } from '@drapejs/core';
import { inject, onMounted } from 'vue';
import { commands } from '../commands/external-payments';
import ProgressIndicator from '@/components/ProgressIndicator.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalPayment',
  setup(__props) {

const route = inject(routeKey);
const invoke = inject(invokeKey);

onMounted(() => {
  if (route) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    invoke!(commands.executeLitiumCallback, { path: `/headless-bridge/${route.pathname}?${route.search}` }).then((res) => {
      window.location = res.redirectUrl;
    });
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProgressIndicator, { isLoading: true })
  ]))
}
}

})